import { addDays, format } from 'date-fns'

const calculateBoundaries = (start, endDate, allDates, intervalDays) => {
  const boundaries = []
  let currentBoundary = start

  // Determine format string based on interval
  let formatString
  if (intervalDays >= 30) {
    formatString = 'MMM' // Monthly: "Jan", "Feb"
  } else if (intervalDays >= 7) {
    formatString = 'MMM d' // Weekly/Bi-weekly: "Jan 15"
  } else {
    formatString = 'MMM d' // Daily/Every few days: "Jan 15"
  }

  while (currentBoundary <= endDate) {
    const boundaryTime = currentBoundary.getTime()
    const dayIndex = allDates.findIndex(date => date.getTime() === boundaryTime)

    if (dayIndex !== -1) {
      boundaries.push({
        date: currentBoundary,
        dayIndex,
        leftPercentage: (dayIndex / allDates.length) * 100,
        label: format(currentBoundary, formatString)
      })
    }

    currentBoundary = addDays(currentBoundary, intervalDays)
  }

  return boundaries
}

export default calculateBoundaries
